import httpClient from "http-client/http-client";

const UPLOAD_PATH = "v1/community-portal/media/upload";

/**
 * Multipart upload to BFF (field name `file`).
 * @param {File} file
 * @param {{ onUploadProgress?: (e: ProgressEvent) => void }} [options]
 * @returns {Promise<{ data: object | null, errors: Array<{ message?: string }> }>}
 */
export async function uploadCommunityPortalMedia(file, { onUploadProgress } = {}) {
  const formData = new FormData();
  formData.append("file", file);
  const { data, errors } = await httpClient.post({
    url: UPLOAD_PATH,
    body: formData,
    onUploadProgress,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
